export const AgTechSystemAdminRole = 'Admin';

export type AgTechOperationUser = {
    id: number,
    firstName: string,
    lastName: string,
    userName: string,
    email: string,
    phoneNumber: string,
    createdDate: Date,
    addresses: AgTechOperationUserAddress[],
    roles: string[]
};

export type AgTechOperationUserAddress = {
    lineOne: string,
    lineTwo: string,
    city: string,
    zip: string,
    userId: string,
    stateProvinceId: number,
    isPrimary: boolean
};

/// Roles

export const UserRoles = {
    operationAdmin: 'OA',
    operationManager: "OM",
    operationLicensing: "OL",
    operationUserManager: "OUM"
};

type UserRolesToNameIndex = {
    [id: string]: string
}

const UserRolesToName: UserRolesToNameIndex = {
    'OA': 'Operation Administrator',
    'OM': 'Operation Manager',
    'OL': 'Operation Licensing',
    'OUM': 'Operation User Manager'
};

export const OperationClaims = {
    enroleInProductClaim: "OPE",
    unenrollInProductClaim: "UIP",
    viewLicenseClaim: "VLC",
    renewLicenseClaim: "RLC",
    deleteLicenseClaim: "DLC",
    viewUsersClaim: "VUC",
    editUsersClaim: "EUC",
    addUsersClaim: "AUC",
    deleteUsersClaim: "DUC",
    addUsersToProductClaim: "AUTPC",
    removeUsersFromProductClaim: "RUFPC",
    updateUsersPermissionsInProductClaim: "UUPIPC",
}
